@if (categories$ | async; as categories) {
  <div class="flex flex-col gap-1">
    @for (category of categories; track category; let isLast = $last) {
      <div class="flex flex-col gap-4">
        <div class="text-lg font-bold">
          {{ category.category }}
        </div>

        @for (method of category.items; track method.id) {
          <div class="text-sm">
            <div class="font-bold">{{ method.name }}</div>
            <div class="text-xs">
              <app-summernote-html-preview [html]="method.description" />
            </div>
          </div>
        }
      </div>

      @if (!isLast) {
        <div class="flex justify-center">
          <p-divider
            appPrimengDivider
            class="w-4/5" />
        </div>
      }
    }
  </div>
} @else {
  <app-spinner-filled />
}
